export default {"src":"/_next/static/media/CHF.80bb8a76.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};